module.exports = __webpack_public_path__ + "static/acupun_2_md-6ea7ea6ba96444fdeb1e3740111ab568.webp";